import React, { ChangeEvent } from 'react';
import { Card, CardHeader, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getInitials } from '../../../../helpers/initialsExtractor';
import { clearIcon, notClearIcon } from '../../../../assets/icons';
import { Avatar } from '../../../../components/avatar/avatar';
import { Button } from '../../../../components/button/button';
import { Checkbox } from '../../../../components/checkBox/checkBox';

interface AllocateProps {
  name: string;
  bday?: string;
  onAllocate: (id: string) => void;
  onRemoveAllocate: (mode: 'players' | 'manager' | boolean, id: string) => void;
  allocateById: string;
  isAllocated: boolean;
  type?: 'add' | 'list';
  mode: 'players' | 'manager' | boolean;
  clearedToPlay?: boolean;
}

export const Allocate = ({
  name,
  bday,
  clearedToPlay,
  onAllocate,
  allocateById,
  isAllocated,
  type = 'add',
  onRemoveAllocate,
  mode,
}: AllocateProps) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ boxShadow: 'none', borderRadius: 4 }} raised={false}>
      <CardHeader
        avatar={<Avatar title={getInitials(name)} />}
        title={
          <Grid
            display="flex"
            flexDirection="row"
            alignItems="center"
            columnGap={1}
          >
            {mode === 'players' &&
              (clearedToPlay !== undefined && clearedToPlay ? (
                <>{clearIcon}</>
              ) : (
                <> {notClearIcon}</>
              ))}
            {name}
          </Grid>
        }
        titleTypographyProps={{ variant: 'subtitle1' }}
        subheader={<Typography>{bday}</Typography>}
        subheaderTypographyProps={{ variant: 'subtitle1' }}
        action={
          <Grid sx={{ ml: 8 }}>
            {type === 'add' && (
              <Checkbox
                name="allocateById"
                label={t('ADD')}
                checked={isAllocated}
                onChange={() => onAllocate(allocateById)}
                testId={`allocateItem-${name.replace(' ', '')}`}
              />
            )}
            {type === 'list' && (
              <Button
                testId={`removeAllocated-${name.replace(' ', '')}`}
                type="submit"
                variant="text"
                data-mode={mode}
                data-id={allocateById}
                onClick={() => onRemoveAllocate(mode, allocateById)}
                label={t('REMOVE')}
                color="error"
              />
            )}
          </Grid>
        }
      />
    </Card>
  );
};
